import { Suspense } from 'react';
import { Flex, Spinner, StackScreen, useScreenSize } from '@banhala/ui-kit';
import { AnalyticsScreen } from 'shared/src/context';
import { SideMenu } from './components/SideMenu';
import { CategoryContent } from './components/CategoryContent';
import { useOverviewCategories } from './queries/useOverviewCategories';
import { useScrollSync } from './hooks/useScrollSync';
import { useLogViewOverview } from './hooks/useLogViewOverview';
import { CartIcon, SearchIcon } from 'shared/src/component';
import { useHasBeenFocusedTab } from 'shared/src/hooks';

const CategoryScreenContent = () => {
  useLogViewOverview();
  const { data } = useOverviewCategories();
  const categories = data.item_list;

  const {
    activeIndex,
    contentRef,
    sideMenuRef,
    handleSectionLayout,
    handleContentScroll,
    handleMenuPress,
  } = useScrollSync();

  const { width: screenWidth } = useScreenSize();

  return (
    <Flex.Row flex={1} width={screenWidth}>
      <Flex flex={1}>
        <SideMenu
          categories={categories}
          activeIndex={activeIndex}
          scrollViewRef={sideMenuRef}
          onMenuPress={handleMenuPress}
        />
      </Flex>
      <Flex flex={2.27}>
        <CategoryContent
          categories={categories}
          contentRef={contentRef}
          onScroll={handleContentScroll}
          onSectionLayout={handleSectionLayout}
        />
      </Flex>
    </Flex.Row>
  );
};

export const CategoryScreen = () => {
  const hasBeenFocused = useHasBeenFocusedTab();

  return (
    <AnalyticsScreen screen="OVERVIEW" hostsModals={false}>
      <StackScreen
        title={'카테고리'}
        hideBackButton={true}
        rightIcons={[<SearchIcon />, <CartIcon />]}
      >
        <Suspense
          fallback={
            <Flex.Center flex={1}>
              <Spinner />
            </Flex.Center>
          }
        >
          <Flex flex={1} alignItems={'center'}>
            {hasBeenFocused && <CategoryScreenContent />}
          </Flex>
        </Suspense>
      </StackScreen>
    </AnalyticsScreen>
  );
};
